import React from 'react';
import { FormControl } from 'react-bootstrap';
import ParticipationsHeader from '../participations-table/ParticipationsHeader.jsx';
import ParticipationsTree from '../participations-table/ParticipationsTree.jsx';
import ParticipationsTable from '../participations-table/table/index.jsx';
import { flattenedTree, getOrgSlug } from '../../lib/utils.js';
import styles from './ChangeInsightsDetails.module.css';

const ChangeInsightsDetails = ({
  initiative,
  isPreview,
  initiativeParticipationId,
  stakeholderParticipationId,
  initiativeParticipation,
  initiativeStakeholderParticipation,
  initiativeParticipations,
  organization,
  status,
  sentiment,
  changeInsightSettings,
  surveyResponses,
  ancestryInitiativeParticipations,
  initiativeStakeholders,
  stakeholders,
  query,
  handleResetSearch,
  handleSearch,
  searchQuery,
  search,
}) => {
  const handleClickViewRespondentAnswers = (surveyResponseId) => {
    if (initiative) {
      window.open(
        `/${getOrgSlug()}/${initiative.type}/${initiative.id}/change-insights/${initiative.surveyId}/results/${surveyResponseId}`,
        '_blank'
      );
    }
  };

  const renderInitiativeParticipations = () => {
    const resultCount = () => {
      return (
        flattenedTree(
          initiativeParticipations.filter(
            (i) => i.participantType === 'Employee'
          )
        ).length +
        initiativeParticipations.filter((i) => i.participantType === 'Group')
          .length
      );
    };

    return (
      <React.Fragment>
        <ParticipationsHeader
          title="Participating Groups"
          initiative={initiative}
          resultsCount={resultCount()}
          initiativeParticipation={initiativeParticipation}
          initiativeParticipations={initiativeParticipations}
          handleSearch={handleSearch}
          searchQuery={searchQuery}
        />
        <div className={styles.initiativeParticipations}>
          <div
            className={`${styles.initiativeParticipationTree} component component-bg-white component-border-right`}
          >
            <ParticipationsTree
              typeParticipating="participant"
              isPreview={isPreview}
              initiative={initiative}
              initiativeParticipations={ancestryInitiativeParticipations}
              activeInitiativeParticipationId={initiativeParticipationId}
              organization={organization}
              status={status}
              sentiment={sentiment}
              handleResetSearch={handleResetSearch}
            />
          </div>
          <div className="flex-1 component-bg-white ">
            <div className="component component-sm flex flex-justify flex-1">
              <h4>
                {initiativeParticipation
                  ? initiativeParticipation.label
                  : organization.name}
              </h4>
              <div style={{ width: '100%', maxWidth: '500px' }}>
                <FormControl
                  placeholder="Search"
                  type="text"
                  className="search-icon m-r-30"
                  onChange={(e) => handleSearch(e.target.value, 'groupSearch')}
                  value={search.groupSearch}
                />
              </div>
            </div>
            <ParticipationsTable
              title="Employee / Group"
              isPreview={isPreview}
              initiative={initiative}
              survey={changeInsightSettings}
              surveyResponses={surveyResponses}
              searchQuery={searchQuery}
              query={query}
              typeParticipating="participant"
              initiativeGroupParticipations={ancestryInitiativeParticipations}
              initiativeParticipations={initiativeParticipations}
              initiativeParticipationId={initiativeParticipationId}
              handleClickViewRespondentAnswers={
                handleClickViewRespondentAnswers
              }
              handleSearch={handleSearch}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  const renderInitiativeStakeholders = () => {
    return (
      <React.Fragment>
        <ParticipationsHeader
          title="Participating Stakeholders"
          initiative={initiative}
          resultsCount={stakeholders.length}
          initiativeParticipation={initiativeStakeholderParticipation}
          initiativeParticipations={stakeholders}
          handleSearch={handleSearch}
          searchQuery={searchQuery}
        />
        <div className={styles.initiativeParticipations}>
          <div
            className={`${styles.initiativeParticipationTree} component component-bg-white component-border-right`}
          >
            <ParticipationsTree
              typeParticipating="stakeholder"
              isPreview={isPreview}
              initiative={initiative}
              initiativeParticipations={initiativeStakeholders}
              activeInitiativeParticipationId={stakeholderParticipationId}
              organization={organization}
              status={status}
              sentiment={sentiment}
              handleResetSearch={handleResetSearch}
            />
          </div>
          <div className="flex-1 component-bg-white ">
            <div className="component component-sm flex flex-justify flex-1">
              <h4>
                {initiativeStakeholderParticipation
                  ? initiativeStakeholderParticipation.name
                  : organization.name}
              </h4>
              <div style={{ width: '100%', maxWidth: '500px' }}>
                <FormControl
                  placeholder="Search"
                  type="text"
                  className="search-icon m-r-30"
                  onChange={(e) => {
                    handleSearch(e.target.value, 'stakeholderSearch');
                  }}
                  value={search.stakeholderSearch}
                />
              </div>
            </div>
            <ParticipationsTable
              title="Group / Individual"
              typeParticipating="stakeholder"
              isPreview={isPreview}
              initiative={initiative}
              survey={changeInsightSettings}
              surveyResponses={surveyResponses}
              searchQuery={searchQuery}
              query={query}
              initiativeParticipations={stakeholders}
              initiativeParticipationId={stakeholderParticipationId}
              handleClickViewRespondentAnswers={
                handleClickViewRespondentAnswers
              }
            />
          </div>
        </div>
      </React.Fragment>
    );
  };

  return (
    <React.Fragment>
      {initiativeParticipations ? renderInitiativeParticipations() : null}
      {initiativeStakeholders
        ? renderInitiativeStakeholders(initiativeStakeholders)
        : null}
    </React.Fragment>
  );
};

export default ChangeInsightsDetails;
